import { SavedView } from '../models/savedView';
import { savedViewSchema } from '../models/savedView.schema';
import { createSavedViewPayloadSchema } from './create.schema';

export type SavedViewCreateFields = Pick<
  SavedView,
  'name' | 'query' | 'shared' | 'queuesFilter'
>;

export type CreateSavedViewPayload = SavedViewCreateFields;

export const create = (payload: CreateSavedViewPayload) => {
  return {
    endpoint: `/saved_views`,
    method: 'POST',
    payload,
    responseSchema: savedViewSchema,
    payloadSchema: createSavedViewPayloadSchema,
  } as const;
};
